import request from '@/utils/request'


// 查询直播礼物列表
export function listGift(query) {
  return request({
    url: '/live/gift/list',
    method: 'get',
    params: query
  })
}

// 查询直播礼物分页
export function pageGift(query) {
  return request({
    url: '/live/gift/page',
    method: 'get',
    params: query
  })
}

// 查询直播礼物详细
export function getGift(data) {
  return request({
    url: '/live/gift/detail',
    method: 'get',
    params: data
  })
}

// 新增直播礼物
export function addGift(data) {
  return request({
    url: '/live/gift/add',
    method: 'post',
    data: data
  })
}

// 修改直播礼物
export function updateGift(data) {
  return request({
    url: '/live/gift/edit',
    method: 'post',
    data: data
  })
}

// 删除直播礼物
export function delGift(data) {
  return request({
    url: '/live/gift/delete',
    method: 'post',
    data: data
  })
}
